export const ThemeCategoryDescriptions = {
  TRADING: 'Themes that you would like Modeling to trade. Performance will be viewable for all trading themes.',
  MONITORING:
    'Themes that you would like to monitor for your own purposes. Performance will be viewable for all monitoring themes.',
  NON_HEDGING: (
    <>
      These themes can be populated with stocks you do <b>not</b> want Modeling to use for hedging purposes when trading
      your Portfolio or Theme data. These themes are directionless and all stocks should be added to Long. Performance
      will not be calculated for non-hedging themes.
    </>
  ),
  NON_HEDGING_SHORTER: (
    <>
      These themes can be populated with stocks you do <b>not</b> want Modeling to use for hedging purposes when trading
      your Portfolio or Theme data. Performance will not be calculated for non-hedging themes.
    </>
  ),
  RADAR:
    'Themes for high conviction companies that you are not yet ready to trade but would like to make available to modeling. Performance will be viewable for the radar theme.',
  RADAR_RESTRICTION: (
    <>
      <b>Only one</b> radar theme is allowed per risk group, whether active or archived.
    </>
  ),
};
